/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * Gets the bill of lading charges.
     * @param bolNumber Gets or sets the bol number.
     * @param storageToDate Gets or sets the storage to date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getBillOfLadingCharges(bolNumber: string, storageToDate: string): Promise<BolChargesResponseDto>;
    /**
     * Gets the bill of lading charges without verification test.
     * @param bolNumber Gets or sets the bol number.
     * @param storageToDate Gets or sets the storage to date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getBillOfLadingInfo(bolNumber: string, storageToDate: string): Promise<BolChargesResponseDto>;
    /**
     * Gets the current APM exchange rates.
     * @return Success
     */
    getCurrentExchangeRates(): Promise<ExchangeRateResponseDto>;
    /**
     * Gets the stripping schedule.
     * @param containerNumber (optional) Gets or sets the container number.
     * @param stripDate (optional) Gets or sets the strip date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getStrippingSchedule(containerNumber: string | null | undefined, stripDate: string | null | undefined): Promise<StrippingScheduleResponseDto>;
    /**
     * Gets the vessel schedule.
     * @param shipName (optional) Gets or sets the name of the ship.
     * @param arrivalDate (optional) Gets or sets the arrival date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getVesselSchedule(shipName: string | null | undefined, arrivalDate: string | null | undefined): Promise<VesselScheduleResponseDto>;
    /**
     * Gets the vessel schedule.
     * @param orderReference (optional) 
     * @param customerRelease (optional) 
     * @return Success
     */
    generateGatePass(orderReference: string | null | undefined, customerRelease: string | null | undefined): Promise<GenerateGatePassResponseDto>;
    /**
     * Flags or Unflags a BOL as a ClickNGo BOL.
     * @param isClickAndGo (optional) 
     * @param bolNumber (optional) 
     * @return Success
     */
    flagBolAsClickAndGo(isClickAndGo: boolean | null | undefined, bolNumber: string | null | undefined): Promise<FlagBolAsClickAndGoResponseDto>;
    /**
     * Gets BL for a Consignee schedule (by customer number
     * @param customerCode (optional) 
     * @return Success
     */
    getBLbyConsignee(customerCode: string | null | undefined): Promise<GetBLbyConsigneeResponseDto>;
    /**
     * Gets the bill of lading payment receipt.
     * @param request (optional) The request.
     * @param client_ID API Client ID
     * @param client_Secret API Client Secret
     * @return Success
     */
    getBillOfLadingPaymentReceipt(request: ApmRecieptRequestDto | null | undefined, client_ID: any, client_Secret: any): Promise<ApmReceiptResponseDto>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/";
    }

    /**
     * Gets the bill of lading charges.
     * @param bolNumber Gets or sets the bol number.
     * @param storageToDate Gets or sets the storage to date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getBillOfLadingCharges(bolNumber: string, storageToDate: string , cancelToken?: CancelToken | undefined): Promise<BolChargesResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetBillOfLadingCharges?";
        if (bolNumber === undefined || bolNumber === null)
            throw new Error("The parameter 'bolNumber' must be defined and cannot be null.");
        else
            url_ += "BolNumber=" + encodeURIComponent("" + bolNumber) + "&";
        if (storageToDate === undefined || storageToDate === null)
            throw new Error("The parameter 'storageToDate' must be defined and cannot be null.");
        else
            url_ += "StorageToDate=" + encodeURIComponent("" + storageToDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillOfLadingCharges(_response);
        });
    }

    protected processGetBillOfLadingCharges(response: AxiosResponse): Promise<BolChargesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BolChargesResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BolChargesResponseDto>(<any>null);
    }

    /**
     * Gets the bill of lading charges without verification test.
     * @param bolNumber Gets or sets the bol number.
     * @param storageToDate Gets or sets the storage to date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getBillOfLadingInfo(bolNumber: string, storageToDate: string , cancelToken?: CancelToken | undefined): Promise<BolChargesResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetBillOfLadingInfo?";
        if (bolNumber === undefined || bolNumber === null)
            throw new Error("The parameter 'bolNumber' must be defined and cannot be null.");
        else
            url_ += "BolNumber=" + encodeURIComponent("" + bolNumber) + "&";
        if (storageToDate === undefined || storageToDate === null)
            throw new Error("The parameter 'storageToDate' must be defined and cannot be null.");
        else
            url_ += "StorageToDate=" + encodeURIComponent("" + storageToDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillOfLadingInfo(_response);
        });
    }

    protected processGetBillOfLadingInfo(response: AxiosResponse): Promise<BolChargesResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BolChargesResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BolChargesResponseDto>(<any>null);
    }

    /**
     * Gets the current APM exchange rates.
     * @return Success
     */
    getCurrentExchangeRates(  cancelToken?: CancelToken | undefined): Promise<ExchangeRateResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetCurrentExchangeRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentExchangeRates(_response);
        });
    }

    protected processGetCurrentExchangeRates(response: AxiosResponse): Promise<ExchangeRateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExchangeRateResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExchangeRateResponseDto>(<any>null);
    }

    /**
     * Gets the stripping schedule.
     * @param containerNumber (optional) Gets or sets the container number.
     * @param stripDate (optional) Gets or sets the strip date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getStrippingSchedule(containerNumber: string | null | undefined, stripDate: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<StrippingScheduleResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetStrippingSchedule?";
        if (containerNumber !== undefined && containerNumber !== null)
            url_ += "ContainerNumber=" + encodeURIComponent("" + containerNumber) + "&";
        if (stripDate !== undefined && stripDate !== null)
            url_ += "StripDate=" + encodeURIComponent("" + stripDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStrippingSchedule(_response);
        });
    }

    protected processGetStrippingSchedule(response: AxiosResponse): Promise<StrippingScheduleResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StrippingScheduleResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StrippingScheduleResponseDto>(<any>null);
    }

    /**
     * Gets the vessel schedule.
     * @param shipName (optional) Gets or sets the name of the ship.
     * @param arrivalDate (optional) Gets or sets the arrival date. Format must be yyyymmdd e.g 20180718
     * @return Success
     */
    getVesselSchedule(shipName: string | null | undefined, arrivalDate: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<VesselScheduleResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetVesselSchedule?";
        if (shipName !== undefined && shipName !== null)
            url_ += "ShipName=" + encodeURIComponent("" + shipName) + "&";
        if (arrivalDate !== undefined && arrivalDate !== null)
            url_ += "ArrivalDate=" + encodeURIComponent("" + arrivalDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVesselSchedule(_response);
        });
    }

    protected processGetVesselSchedule(response: AxiosResponse): Promise<VesselScheduleResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VesselScheduleResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VesselScheduleResponseDto>(<any>null);
    }

    /**
     * Gets the vessel schedule.
     * @param orderReference (optional) 
     * @param customerRelease (optional) 
     * @return Success
     */
    generateGatePass(orderReference: string | null | undefined, customerRelease: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GenerateGatePassResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GenerateGatePass?";
        if (orderReference !== undefined && orderReference !== null)
            url_ += "OrderReference=" + encodeURIComponent("" + orderReference) + "&";
        if (customerRelease !== undefined && customerRelease !== null)
            url_ += "CustomerRelease=" + encodeURIComponent("" + customerRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateGatePass(_response);
        });
    }

    protected processGenerateGatePass(response: AxiosResponse): Promise<GenerateGatePassResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateGatePassResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateGatePassResponseDto>(<any>null);
    }

    /**
     * Flags or Unflags a BOL as a ClickNGo BOL.
     * @param isClickAndGo (optional) 
     * @param bolNumber (optional) 
     * @return Success
     */
    flagBolAsClickAndGo(isClickAndGo: boolean | null | undefined, bolNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FlagBolAsClickAndGoResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/FlagBolAsClickAndGo?";
        if (isClickAndGo !== undefined && isClickAndGo !== null)
            url_ += "IsClickAndGo=" + encodeURIComponent("" + isClickAndGo) + "&";
        if (bolNumber !== undefined && bolNumber !== null)
            url_ += "BolNumber=" + encodeURIComponent("" + bolNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlagBolAsClickAndGo(_response);
        });
    }

    protected processFlagBolAsClickAndGo(response: AxiosResponse): Promise<FlagBolAsClickAndGoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlagBolAsClickAndGoResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlagBolAsClickAndGoResponseDto>(<any>null);
    }

    /**
     * Gets BL for a Consignee schedule (by customer number
     * @param customerCode (optional) 
     * @return Success
     */
    getBLbyConsignee(customerCode: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetBLbyConsigneeResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetBLbyConsignee?";
        if (customerCode !== undefined && customerCode !== null)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBLbyConsignee(_response);
        });
    }

    protected processGetBLbyConsignee(response: AxiosResponse): Promise<GetBLbyConsigneeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBLbyConsigneeResponseDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBLbyConsigneeResponseDto>(<any>null);
    }

    /**
     * Gets the bill of lading payment receipt.
     * @param request (optional) The request.
     * @param client_ID API Client ID
     * @param client_Secret API Client Secret
     * @return Success
     */
    getBillOfLadingPaymentReceipt(request: ApmRecieptRequestDto | null | undefined, client_ID: any, client_Secret: any , cancelToken?: CancelToken | undefined): Promise<ApmReceiptResponseDto> {
        let url_ = this.baseUrl + "/v1/ApmServices/GetBillOfLadingPaymentReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Client-ID": client_ID !== undefined && client_ID !== null ? "" + client_ID : "",
                "Client-Secret": client_Secret !== undefined && client_Secret !== null ? "" + client_Secret : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillOfLadingPaymentReceipt(_response);
        });
    }

    protected processGetBillOfLadingPaymentReceipt(response: AxiosResponse): Promise<ApmReceiptResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApmReceiptResponseDto.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApmReceiptResponseDto>(<any>null);
    }
}

export class BolChargesResponseDto implements IBolChargesResponseDto {
    bolReferenceNos?: string[] | undefined;
    bolExtraData?: BolListData[] | undefined;
    storageDueDate?: string | undefined;
    shipName?: string | undefined;
    arrivalDate?: string | undefined;
    errors?: string[] | undefined;
    data?: BolCharge[] | undefined;

    constructor(data?: IBolChargesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bolExtraData) {
                this.bolExtraData = [];
                for (let i = 0; i < data.bolExtraData.length; i++) {
                    let item = data.bolExtraData[i];
                    this.bolExtraData[i] = item && !(<any>item).toJSON ? new BolListData(item) : <BolListData>item;
                }
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BolCharge(item) : <BolCharge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bolReferenceNos"])) {
                this.bolReferenceNos = [] as any;
                for (let item of _data["bolReferenceNos"])
                    this.bolReferenceNos!.push(item);
            }
            if (Array.isArray(_data["bolExtraData"])) {
                this.bolExtraData = [] as any;
                for (let item of _data["bolExtraData"])
                    this.bolExtraData!.push(BolListData.fromJS(item));
            }
            this.storageDueDate = _data["storageDueDate"];
            this.shipName = _data["shipName"];
            this.arrivalDate = _data["arrivalDate"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BolCharge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BolChargesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BolChargesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bolReferenceNos)) {
            data["bolReferenceNos"] = [];
            for (let item of this.bolReferenceNos)
                data["bolReferenceNos"].push(item);
        }
        if (Array.isArray(this.bolExtraData)) {
            data["bolExtraData"] = [];
            for (let item of this.bolExtraData)
                data["bolExtraData"].push(item.toJSON());
        }
        data["storageDueDate"] = this.storageDueDate;
        data["shipName"] = this.shipName;
        data["arrivalDate"] = this.arrivalDate;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BolChargesResponseDto {
        const json = this.toJSON();
        let result = new BolChargesResponseDto();
        result.init(json);
        return result;
    }
}

export interface IBolChargesResponseDto {
    bolReferenceNos?: string[] | undefined;
    bolExtraData?: IBolListData[] | undefined;
    storageDueDate?: string | undefined;
    shipName?: string | undefined;
    arrivalDate?: string | undefined;
    errors?: string[] | undefined;
    data?: IBolCharge[] | undefined;
}

export class BolListData implements IBolListData {
    bilReference?: string | undefined;
    bolNumber?: string | undefined;
    itemNo?: string | undefined;
    bolType?: string | undefined;
    description?: string | undefined;
    released?: boolean | undefined;
    approved?: boolean | undefined;
    clickAndGo?: boolean | undefined;
    tallyStatus?: string | undefined;
    customerName?: string | undefined;
    shipperName?: string | undefined;
    numberOfPieces?: string[] | undefined;

    constructor(data?: IBolListData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bilReference = _data["bilReference"];
            this.bolNumber = _data["bolNumber"];
            this.itemNo = _data["itemNo"];
            this.bolType = _data["bolType"];
            this.description = _data["description"];
            this.released = _data["released"];
            this.approved = _data["approved"];
            this.clickAndGo = _data["clickAndGo"];
            this.tallyStatus = _data["tallyStatus"];
            this.customerName = _data["customerName"];
            this.shipperName = _data["shipperName"];
            if (Array.isArray(_data["numberOfPieces"])) {
                this.numberOfPieces = [] as any;
                for (let item of _data["numberOfPieces"])
                    this.numberOfPieces!.push(item);
            }
        }
    }

    static fromJS(data: any): BolListData {
        data = typeof data === 'object' ? data : {};
        let result = new BolListData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bilReference"] = this.bilReference;
        data["bolNumber"] = this.bolNumber;
        data["itemNo"] = this.itemNo;
        data["bolType"] = this.bolType;
        data["description"] = this.description;
        data["released"] = this.released;
        data["approved"] = this.approved;
        data["clickAndGo"] = this.clickAndGo;
        data["tallyStatus"] = this.tallyStatus;
        data["customerName"] = this.customerName;
        data["shipperName"] = this.shipperName;
        if (Array.isArray(this.numberOfPieces)) {
            data["numberOfPieces"] = [];
            for (let item of this.numberOfPieces)
                data["numberOfPieces"].push(item);
        }
        return data; 
    }

    clone(): BolListData {
        const json = this.toJSON();
        let result = new BolListData();
        result.init(json);
        return result;
    }
}

export interface IBolListData {
    bilReference?: string | undefined;
    bolNumber?: string | undefined;
    itemNo?: string | undefined;
    bolType?: string | undefined;
    description?: string | undefined;
    released?: boolean | undefined;
    approved?: boolean | undefined;
    clickAndGo?: boolean | undefined;
    tallyStatus?: string | undefined;
    customerName?: string | undefined;
    shipperName?: string | undefined;
    numberOfPieces?: string[] | undefined;
}

export class BolCharge implements IBolCharge {
    chargeType?: string | undefined;
    chargeAmount?: number | undefined;

    constructor(data?: IBolCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeType = _data["chargeType"];
            this.chargeAmount = _data["chargeAmount"];
        }
    }

    static fromJS(data: any): BolCharge {
        data = typeof data === 'object' ? data : {};
        let result = new BolCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeType"] = this.chargeType;
        data["chargeAmount"] = this.chargeAmount;
        return data; 
    }

    clone(): BolCharge {
        const json = this.toJSON();
        let result = new BolCharge();
        result.init(json);
        return result;
    }
}

export interface IBolCharge {
    chargeType?: string | undefined;
    chargeAmount?: number | undefined;
}

export class ExchangeRateResponseDto implements IExchangeRateResponseDto {
    errors?: string[] | undefined;
    data?: ExchangeRate[] | undefined;

    constructor(data?: IExchangeRateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new ExchangeRate(item) : <ExchangeRate>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ExchangeRate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExchangeRateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeRateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExchangeRateResponseDto {
        const json = this.toJSON();
        let result = new ExchangeRateResponseDto();
        result.init(json);
        return result;
    }
}

export interface IExchangeRateResponseDto {
    errors?: string[] | undefined;
    data?: IExchangeRate[] | undefined;
}

export class ExchangeRate implements IExchangeRate {
    currencyCode?: string | undefined;
    rate?: number | undefined;

    constructor(data?: IExchangeRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyCode = _data["currencyCode"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): ExchangeRate {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyCode"] = this.currencyCode;
        data["rate"] = this.rate;
        return data; 
    }

    clone(): ExchangeRate {
        const json = this.toJSON();
        let result = new ExchangeRate();
        result.init(json);
        return result;
    }
}

export interface IExchangeRate {
    currencyCode?: string | undefined;
    rate?: number | undefined;
}

export class StrippingScheduleResponseDto implements IStrippingScheduleResponseDto {
    errors?: string[] | undefined;
    data?: StrippingSchedule[] | undefined;

    constructor(data?: IStrippingScheduleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new StrippingSchedule(item) : <StrippingSchedule>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StrippingSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrippingScheduleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StrippingScheduleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StrippingScheduleResponseDto {
        const json = this.toJSON();
        let result = new StrippingScheduleResponseDto();
        result.init(json);
        return result;
    }
}

export interface IStrippingScheduleResponseDto {
    errors?: string[] | undefined;
    data?: IStrippingSchedule[] | undefined;
}

export class StrippingSchedule implements IStrippingSchedule {
    containerNumber?: string | undefined;
    shipName?: string | undefined;
    scheduledDateAndTime?: string | undefined;
    stripStartDateAndTime?: string | undefined;
    stripEndDateAndTime?: string | undefined;
    stripLocation?: string | undefined;
    processCode?: string | undefined;
    status?: string | undefined;
    category?: string | undefined;

    constructor(data?: IStrippingSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerNumber = _data["containerNumber"];
            this.shipName = _data["shipName"];
            this.scheduledDateAndTime = _data["scheduledDateAndTime"];
            this.stripStartDateAndTime = _data["stripStartDateAndTime"];
            this.stripEndDateAndTime = _data["stripEndDateAndTime"];
            this.stripLocation = _data["stripLocation"];
            this.processCode = _data["processCode"];
            this.status = _data["status"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): StrippingSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new StrippingSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerNumber"] = this.containerNumber;
        data["shipName"] = this.shipName;
        data["scheduledDateAndTime"] = this.scheduledDateAndTime;
        data["stripStartDateAndTime"] = this.stripStartDateAndTime;
        data["stripEndDateAndTime"] = this.stripEndDateAndTime;
        data["stripLocation"] = this.stripLocation;
        data["processCode"] = this.processCode;
        data["status"] = this.status;
        data["category"] = this.category;
        return data; 
    }

    clone(): StrippingSchedule {
        const json = this.toJSON();
        let result = new StrippingSchedule();
        result.init(json);
        return result;
    }
}

export interface IStrippingSchedule {
    containerNumber?: string | undefined;
    shipName?: string | undefined;
    scheduledDateAndTime?: string | undefined;
    stripStartDateAndTime?: string | undefined;
    stripEndDateAndTime?: string | undefined;
    stripLocation?: string | undefined;
    processCode?: string | undefined;
    status?: string | undefined;
    category?: string | undefined;
}

export class VesselScheduleResponseDto implements IVesselScheduleResponseDto {
    errors?: string[] | undefined;
    data?: VesselSchedule[] | undefined;

    constructor(data?: IVesselScheduleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new VesselSchedule(item) : <VesselSchedule>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VesselSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VesselScheduleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VesselScheduleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VesselScheduleResponseDto {
        const json = this.toJSON();
        let result = new VesselScheduleResponseDto();
        result.init(json);
        return result;
    }
}

export interface IVesselScheduleResponseDto {
    errors?: string[] | undefined;
    data?: IVesselSchedule[] | undefined;
}

export class VesselSchedule implements IVesselSchedule {
    shipName?: string | undefined;
    imoCode?: string | undefined;
    arrivalDateTime?: string | undefined;
    expectedArrivalDateTime?: string | undefined;
    lineName?: string | undefined;

    constructor(data?: IVesselSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipName = _data["shipName"];
            this.imoCode = _data["imoCode"];
            this.arrivalDateTime = _data["arrivalDateTime"];
            this.expectedArrivalDateTime = _data["expectedArrivalDateTime"];
            this.lineName = _data["lineName"];
        }
    }

    static fromJS(data: any): VesselSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new VesselSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipName"] = this.shipName;
        data["imoCode"] = this.imoCode;
        data["arrivalDateTime"] = this.arrivalDateTime;
        data["expectedArrivalDateTime"] = this.expectedArrivalDateTime;
        data["lineName"] = this.lineName;
        return data; 
    }

    clone(): VesselSchedule {
        const json = this.toJSON();
        let result = new VesselSchedule();
        result.init(json);
        return result;
    }
}

export interface IVesselSchedule {
    shipName?: string | undefined;
    imoCode?: string | undefined;
    arrivalDateTime?: string | undefined;
    expectedArrivalDateTime?: string | undefined;
    lineName?: string | undefined;
}

export class GenerateGatePassResponseDto implements IGenerateGatePassResponseDto {
    ordreference?: string | undefined;
    gatePassNumber?: string | undefined;
    gatePassDate?: string | undefined;
    gptype?: string | undefined;
    customer?: string | undefined;
    address?: string | undefined;
    bilReference?: string | undefined;
    bilNumber?: string | undefined;
    itemNumber?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    reportdate?: string | undefined;
    berth?: string | undefined;
    clickngo?: boolean | undefined;
    data?: Datum[] | undefined;
    orderType?: string | undefined;
    cnsign?: string | undefined;
    cnsadd?: string | undefined;
    error?: string[] | undefined;

    constructor(data?: IGenerateGatePassResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new Datum(item) : <Datum>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordreference = _data["ordreference"];
            this.gatePassNumber = _data["gatePassNumber"];
            this.gatePassDate = _data["gatePassDate"];
            this.gptype = _data["gptype"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.bilReference = _data["bilReference"];
            this.bilNumber = _data["bilNumber"];
            this.itemNumber = _data["itemNumber"];
            this.vessel = _data["vessel"];
            this.voyage = _data["voyage"];
            this.reportdate = _data["reportdate"];
            this.berth = _data["berth"];
            this.clickngo = _data["clickngo"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Datum.fromJS(item));
            }
            this.orderType = _data["orderType"];
            this.cnsign = _data["cnsign"];
            this.cnsadd = _data["cnsadd"];
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateGatePassResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateGatePassResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordreference"] = this.ordreference;
        data["gatePassNumber"] = this.gatePassNumber;
        data["gatePassDate"] = this.gatePassDate;
        data["gptype"] = this.gptype;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["bilReference"] = this.bilReference;
        data["bilNumber"] = this.bilNumber;
        data["itemNumber"] = this.itemNumber;
        data["vessel"] = this.vessel;
        data["voyage"] = this.voyage;
        data["reportdate"] = this.reportdate;
        data["berth"] = this.berth;
        data["clickngo"] = this.clickngo;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["orderType"] = this.orderType;
        data["cnsign"] = this.cnsign;
        data["cnsadd"] = this.cnsadd;
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item);
        }
        return data; 
    }

    clone(): GenerateGatePassResponseDto {
        const json = this.toJSON();
        let result = new GenerateGatePassResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGenerateGatePassResponseDto {
    ordreference?: string | undefined;
    gatePassNumber?: string | undefined;
    gatePassDate?: string | undefined;
    gptype?: string | undefined;
    customer?: string | undefined;
    address?: string | undefined;
    bilReference?: string | undefined;
    bilNumber?: string | undefined;
    itemNumber?: string | undefined;
    vessel?: string | undefined;
    voyage?: string | undefined;
    reportdate?: string | undefined;
    berth?: string | undefined;
    clickngo?: boolean | undefined;
    data?: IDatum[] | undefined;
    orderType?: string | undefined;
    cnsign?: string | undefined;
    cnsadd?: string | undefined;
    error?: string[] | undefined;
}

export class Datum implements IDatum {
    description?: string | undefined;
    marks?: string | undefined;
    packtype?: string | undefined;
    quanremain?: number | undefined;
    quanapplied?: number | undefined;

    constructor(data?: IDatum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.marks = _data["marks"];
            this.packtype = _data["packtype"];
            this.quanremain = _data["quanremain"];
            this.quanapplied = _data["quanapplied"];
        }
    }

    static fromJS(data: any): Datum {
        data = typeof data === 'object' ? data : {};
        let result = new Datum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["marks"] = this.marks;
        data["packtype"] = this.packtype;
        data["quanremain"] = this.quanremain;
        data["quanapplied"] = this.quanapplied;
        return data; 
    }

    clone(): Datum {
        const json = this.toJSON();
        let result = new Datum();
        result.init(json);
        return result;
    }
}

export interface IDatum {
    description?: string | undefined;
    marks?: string | undefined;
    packtype?: string | undefined;
    quanremain?: number | undefined;
    quanapplied?: number | undefined;
}

export class FlagBolAsClickAndGoResponseDto implements IFlagBolAsClickAndGoResponseDto {
    status?: string | undefined;
    vessel?: string | undefined;
    reportedDate?: string | undefined;
    voyage?: string | undefined;
    billReferences?: string[] | undefined;
    errors?: string[] | undefined;
    data?: string[] | undefined;

    constructor(data?: IFlagBolAsClickAndGoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.vessel = _data["vessel"];
            this.reportedDate = _data["reportedDate"];
            this.voyage = _data["voyage"];
            if (Array.isArray(_data["billReferences"])) {
                this.billReferences = [] as any;
                for (let item of _data["billReferences"])
                    this.billReferences!.push(item);
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): FlagBolAsClickAndGoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlagBolAsClickAndGoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["vessel"] = this.vessel;
        data["reportedDate"] = this.reportedDate;
        data["voyage"] = this.voyage;
        if (Array.isArray(this.billReferences)) {
            data["billReferences"] = [];
            for (let item of this.billReferences)
                data["billReferences"].push(item);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data; 
    }

    clone(): FlagBolAsClickAndGoResponseDto {
        const json = this.toJSON();
        let result = new FlagBolAsClickAndGoResponseDto();
        result.init(json);
        return result;
    }
}

export interface IFlagBolAsClickAndGoResponseDto {
    status?: string | undefined;
    vessel?: string | undefined;
    reportedDate?: string | undefined;
    voyage?: string | undefined;
    billReferences?: string[] | undefined;
    errors?: string[] | undefined;
    data?: string[] | undefined;
}

export class GetBLbyConsigneeResponseDto implements IGetBLbyConsigneeResponseDto {
    customerName?: string | undefined;
    trn?: string | undefined;
    customerCode?: string | undefined;
    errors?: string[] | undefined;
    data?: BolListData[] | undefined;

    constructor(data?: IGetBLbyConsigneeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BolListData(item) : <BolListData>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.trn = _data["trn"];
            this.customerCode = _data["customerCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BolListData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBLbyConsigneeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBLbyConsigneeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["trn"] = this.trn;
        data["customerCode"] = this.customerCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetBLbyConsigneeResponseDto {
        const json = this.toJSON();
        let result = new GetBLbyConsigneeResponseDto();
        result.init(json);
        return result;
    }
}

export interface IGetBLbyConsigneeResponseDto {
    customerName?: string | undefined;
    trn?: string | undefined;
    customerCode?: string | undefined;
    errors?: string[] | undefined;
    data?: IBolListData[] | undefined;
}

export class ApmRecieptRequestDto implements IApmRecieptRequestDto {
    /** Gets or sets the BOL items. */
    bolItems?: BolItem[] | undefined;
    /** Gets or sets the total amount. */
    totalAmount?: number | undefined;
    /** Gets or sets the type of the payment, 'CreditCard or PayPal' */
    paymentType?: string | undefined;
    cashierId!: string;

    constructor(data?: IApmRecieptRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bolItems) {
                this.bolItems = [];
                for (let i = 0; i < data.bolItems.length; i++) {
                    let item = data.bolItems[i];
                    this.bolItems[i] = item && !(<any>item).toJSON ? new BolItem(item) : <BolItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bolItems"])) {
                this.bolItems = [] as any;
                for (let item of _data["bolItems"])
                    this.bolItems!.push(BolItem.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
            this.paymentType = _data["paymentType"];
            this.cashierId = _data["cashierId"];
        }
    }

    static fromJS(data: any): ApmRecieptRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApmRecieptRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bolItems)) {
            data["bolItems"] = [];
            for (let item of this.bolItems)
                data["bolItems"].push(item.toJSON());
        }
        data["totalAmount"] = this.totalAmount;
        data["paymentType"] = this.paymentType;
        data["cashierId"] = this.cashierId;
        return data; 
    }

    clone(): ApmRecieptRequestDto {
        const json = this.toJSON();
        let result = new ApmRecieptRequestDto();
        result.init(json);
        return result;
    }
}

export interface IApmRecieptRequestDto {
    /** Gets or sets the BOL items. */
    bolItems?: IBolItem[] | undefined;
    /** Gets or sets the total amount. */
    totalAmount?: number | undefined;
    /** Gets or sets the type of the payment, 'CreditCard or PayPal' */
    paymentType?: string | undefined;
    cashierId: string;
}

export class BolItem implements IBolItem {
    /** Gets or sets the BOL reference numbers. */
    bolReferenceNumbers?: string[] | undefined;
    /** Gets or sets the BOL storage to date. */
    bolStorageToDate?: string | undefined;

    constructor(data?: IBolItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bolReferenceNumbers"])) {
                this.bolReferenceNumbers = [] as any;
                for (let item of _data["bolReferenceNumbers"])
                    this.bolReferenceNumbers!.push(item);
            }
            this.bolStorageToDate = _data["bolStorageToDate"];
        }
    }

    static fromJS(data: any): BolItem {
        data = typeof data === 'object' ? data : {};
        let result = new BolItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bolReferenceNumbers)) {
            data["bolReferenceNumbers"] = [];
            for (let item of this.bolReferenceNumbers)
                data["bolReferenceNumbers"].push(item);
        }
        data["bolStorageToDate"] = this.bolStorageToDate;
        return data; 
    }

    clone(): BolItem {
        const json = this.toJSON();
        let result = new BolItem();
        result.init(json);
        return result;
    }
}

export interface IBolItem {
    /** Gets or sets the BOL reference numbers. */
    bolReferenceNumbers?: string[] | undefined;
    /** Gets or sets the BOL storage to date. */
    bolStorageToDate?: string | undefined;
}

export class ApmReceiptResponseDto implements IApmReceiptResponseDto {
    receiptNumber?: string | undefined;
    totalAmount?: number | undefined;
    receiptDate?: string | undefined;
    errors?: string[] | undefined;
    data?: BolData[] | undefined;

    constructor(data?: IApmReceiptResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BolData(item) : <BolData>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptNumber = _data["receiptNumber"];
            this.totalAmount = _data["totalAmount"];
            this.receiptDate = _data["receiptDate"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BolData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApmReceiptResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApmReceiptResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        data["totalAmount"] = this.totalAmount;
        data["receiptDate"] = this.receiptDate;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ApmReceiptResponseDto {
        const json = this.toJSON();
        let result = new ApmReceiptResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApmReceiptResponseDto {
    receiptNumber?: string | undefined;
    totalAmount?: number | undefined;
    receiptDate?: string | undefined;
    errors?: string[] | undefined;
    data?: IBolData[] | undefined;
}

export class BolData implements IBolData {
    bolReference?: string | undefined;
    bolNumber?: string | undefined;
    itemNumber?: string | undefined;
    consignee?: string | undefined;
    vessel?: string | undefined;
    voyageNumber?: string | undefined;
    arrivalDate?: string | undefined;
    lineName?: string | undefined;
    orderReference?: string | undefined;
    equipment?: string | undefined;
    location?: string | undefined;
    description?: string | undefined;
    berth?: string | undefined;
    storageDueDate?: string | undefined;
    charges?: BolCharge[] | undefined;
    customerName?: string | undefined;
    numberOfPieces?: string[] | undefined;

    constructor(data?: IBolData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.charges) {
                this.charges = [];
                for (let i = 0; i < data.charges.length; i++) {
                    let item = data.charges[i];
                    this.charges[i] = item && !(<any>item).toJSON ? new BolCharge(item) : <BolCharge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bolReference = _data["bolReference"];
            this.bolNumber = _data["bolNumber"];
            this.itemNumber = _data["itemNumber"];
            this.consignee = _data["consignee"];
            this.vessel = _data["vessel"];
            this.voyageNumber = _data["voyageNumber"];
            this.arrivalDate = _data["arrivalDate"];
            this.lineName = _data["lineName"];
            this.orderReference = _data["orderReference"];
            this.equipment = _data["equipment"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.berth = _data["berth"];
            this.storageDueDate = _data["storageDueDate"];
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(BolCharge.fromJS(item));
            }
            this.customerName = _data["customerName"];
            if (Array.isArray(_data["numberOfPieces"])) {
                this.numberOfPieces = [] as any;
                for (let item of _data["numberOfPieces"])
                    this.numberOfPieces!.push(item);
            }
        }
    }

    static fromJS(data: any): BolData {
        data = typeof data === 'object' ? data : {};
        let result = new BolData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bolReference"] = this.bolReference;
        data["bolNumber"] = this.bolNumber;
        data["itemNumber"] = this.itemNumber;
        data["consignee"] = this.consignee;
        data["vessel"] = this.vessel;
        data["voyageNumber"] = this.voyageNumber;
        data["arrivalDate"] = this.arrivalDate;
        data["lineName"] = this.lineName;
        data["orderReference"] = this.orderReference;
        data["equipment"] = this.equipment;
        data["location"] = this.location;
        data["description"] = this.description;
        data["berth"] = this.berth;
        data["storageDueDate"] = this.storageDueDate;
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        data["customerName"] = this.customerName;
        if (Array.isArray(this.numberOfPieces)) {
            data["numberOfPieces"] = [];
            for (let item of this.numberOfPieces)
                data["numberOfPieces"].push(item);
        }
        return data; 
    }

    clone(): BolData {
        const json = this.toJSON();
        let result = new BolData();
        result.init(json);
        return result;
    }
}

export interface IBolData {
    bolReference?: string | undefined;
    bolNumber?: string | undefined;
    itemNumber?: string | undefined;
    consignee?: string | undefined;
    vessel?: string | undefined;
    voyageNumber?: string | undefined;
    arrivalDate?: string | undefined;
    lineName?: string | undefined;
    orderReference?: string | undefined;
    equipment?: string | undefined;
    location?: string | undefined;
    description?: string | undefined;
    berth?: string | undefined;
    storageDueDate?: string | undefined;
    charges?: IBolCharge[] | undefined;
    customerName?: string | undefined;
    numberOfPieces?: string[] | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}